@if (!isUiTest) {
  <div>
    <div>
      @if (data) {
        <div class="assignAccountsCountText left">
          <span id="activeRowCount">{{activeRowCount}}</span> active notes, <span
        id="archivedRowCount">{{archivedRowCount}}</span> archived notes
      </div>
    }
    <div class="d-flex">
      <div class="multilineText" style="margin-left:60px;">
        <span id="portfolioNotesToolTipIcon" class="infoIcon" calltoaction calltoactionPosition="top"
        [calltoactionTemplate]="portfolioNotesToolTipIcon" calltoactionMaxWidth ='400px'></span>
        <textarea
          id="w3review" name="w3review" rows="4"
          placeholder="Enter your note here, maximum 1,000 characters"
          maxlength="1000"
          onfocus="this.placeholder = ''"
          onblur="this.placeholder = 'Enter your note here, maximum 1,000 characters'"
          (keyup)="onKeyUpChange()" [(ngModel)]="multiLineComment" cols="50"
          [pattern]="notesPattern"
          [ngStyle]="{'borderColor': isNoteBeingEdited ? '#0091ea' : 'initial'}"
          #portNotesTextF
        style="height: 50px;"></textarea>
      </div>
      <div>
        @if (!isNoteBeingEdited) {
          <button class="btn-medium-secondary btn-spacer" [disabled]="canNotCreateNote" (click)="addPorfolioNotes()">
            Create Note
          </button>
        }
        @if (isNoteBeingEdited) {
          <button class="btn-medium-secondary" [disabled]="canNotCreateNote" (click)="updatePortfolioNotes()">
            Update Note
          </button>
        }
        @if (isNoteBeingEdited) {
          <button id="cancelNoteEditButton" label="Cancel" class="btn-medium-secondary" (click)="cancelEditNote()">Cancel </button>
        }
      </div>
    </div>
  </div>
  <div class="hblock">
    <div class="left d-flex">
      <div class="left archiveText">Show:
        <p-radioButton inputId="edallNotes" name="filter" value="allNotes" [(ngModel)]="filterType"
        (ngModelChange)="externalFilterChanged()"></p-radioButton>
        <label for="edallNotes">All</label>&nbsp;
        <p-radioButton inputId="edactiveNotes" name="filter" value="activeNotes" [(ngModel)]="filterType"
        (ngModelChange)="externalFilterChanged()"></p-radioButton>
        <label for="edactiveNotes">Active</label>&nbsp;
        <p-radioButton inputId="edArchivedNotes" name="filter" value="archivedNotes" [(ngModel)]="filterType"
        (ngModelChange)="externalFilterChanged()"></p-radioButton>
        <label for="edArchivedNotes">Archived</label>
      </div>
      @if (!isNoteValid()) {
        <div class="d-flex">
          <div><img class="quick-icons" src="../../assets/images/alert-icon.png"></div>
          <div>Note contains errors... <a calltoaction [calltoactionTemplate]="portfolioNotesPossibleReasonsToolTipIcon"
          calltoactionMaxWidth ='500px'>see possible reasons</a></div>
        </div>
      }
    </div>
    <div class="right" style="margin-right: 1px;">
      <span class="right">
        <fa-icon id="exportLink" [icon]="faDownload" (click)="exportNotes()" class="irb-green clickable" tooltip
        [tooltipTitle]="'Export'"></fa-icon>
      </span>
    </div>
    <br class="clear"/>
  </div>
  <irb-inventory-grid
    class="portfolioNotes"
    [style.width]="'100%'"
    [gridHeight]="'200px'"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [frameworkComponents]='frameworkComponents'
  (gridReady)="onGridReady($event)"></irb-inventory-grid>
  @if (ges.getExportOptions().isGridRequired) {
    <irb-ag-grid-export (callbackMethod)="ges.resetExportGrid()"
      [exportOptions]="ges.getExportOptions()"
      [exportType]="'csv'"
      [isGridRequired]="ges.getExportOptions().isGridRequired"
    [rowData]="ges.getExportOptions().gridOptions.rowData"></irb-ag-grid-export>
  }
</div>
}
<ng-template #portfolioNotesToolTipIcon>
  <div>
    <ul class="portfolio-notes-tool-tip-icon-content">
      <li>Portfolio notes need to begin with an alphanumeric character.</li>
      <li>Within the note, standard keyboard characters only can be used.</li>
      <li>If copy/pasting from a document, rich text formatting can cause conflicts. It is recommended to paste notes in plain text format.</li>
    </ul>

  </div>
</ng-template>

<ng-template #portfolioNotesPossibleReasonsToolTipIcon>
  <div  class="portfolio-notes-possible-reasons-tool-tip-icon-content">
    <p>Possible errors:</p>
    <ul>
      <li>The first character of the note must be an alphanumeric.</li>
      <li>After first character, only standard keyboard characters can be used (listed below).</li>
      <li>If the note was copied/pasted from a document, rich text formatting can cause conflicts. Please re-enter your note, preferably in plain text.</li>
    </ul>
    <p>Keyboard characters</p>
    <div  class="keyboard-characters-allowed" style="display: flex;">
      <div>
        <p>&nbsp; space</p>
        <p>, comma</p>
        <p>. period</p>
        <p>: colon</p>
        <p>; semicolon</p>
        <p>' single quote/apostrophe</p>
        <p>" double quote</p>
        <p>~ tilde</p>
        <p>` backquote</p>
        <p>! exclamation point</p>
        <p>&#64; at symbol</p>
        <p># hash</p>
        <p>$ dollar symbol</p>
        <p>% percent symbol</p>

      </div>
      <div>
        <p>^ circumflex</p>
        <p>& ampersand</p>
        <p>* asterisk</p>
        <p>() parantheses</p>
        <p>- hyphen</p>
        <p>_ underscore</p>
        <p>+ plus</p>
        <p>= equal</p>
        <p>{{ "{" }}{{ "}"}} braces</p>
        <p>[] square brackets</p>
        <p><> carets</p>
        <p>? question mark</p>
        <p>/\ forward and back slashes</p>
        <p>| pipe</p>

      </div>
    </div>
  </div>
</ng-template>
